import api from '@/api';

class RestApiModel {
  /**
   * Ensure that this is overridden
   * @returns {string}
   */
  static getResourceEndpoint() {
    return '';
  }
  static getResourceIdEndpoint(id) {
    return `${this.getResourceEndpoint()}/${id}`;
  }
  static get(id) {
    return api.get(this.getResourceIdEndpoint(id));
  }
  static list(params) {
    return api.get(this.getResourceEndpoint(), params);
  }
  static create(params) {
    return api.post(this.getResourceEndpoint(), params);
  }
  static update(id, params) {
    return api.put(this.getResourceIdEndpoint(id), params);
  }
  static delete(id) {
    return api.delete(this.getResourceIdEndpoint(id));
  }
}

export default RestApiModel;
